import { useCallback, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useAuth } from '@/auth/auth-provider';
import { GoogleButton } from '@/components/google-button';

export function AcceptInvitePage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token');
  const { acceptInvite } = useAuth();
  const initialError = useMemo(() => token ? '' : 'This invitation link is incomplete.', [token]);
  const [error, setError] = useState(initialError);
  const [loading, setLoading] = useState(false);
  const accept = useCallback(async (credential: string) => {
    if (!token) return;
    setLoading(true); setError('');
    try { await acceptInvite(credential, token); navigate('/', { replace: true }); }
    catch (cause) { setError(cause instanceof Error ? cause.message : 'Activation failed'); }
    finally { setLoading(false); }
  }, [acceptInvite, navigate, token]);

  return <main className="login-page">
    <section className="login-hero">
      <div className="brand" style={{ color: 'white', padding: 0 }}><img src="/futsaly-mark.svg" alt="" width={36} height={36} />Futsaly</div>
      <div><span className="badge live">INVITED ACCESS</span><h1>Activate your<br />admin workspace.</h1><p style={{ maxWidth: 560, color: '#c7d6ee', fontSize: 18 }}>Continue with the exact Google account that received this invitation.</p></div>
      <small style={{ color: '#9eb2d2' }}>Invite tokens are single-use and expire automatically.</small>
    </section>
    <section className="login-panel"><div className="card login-card">
      <img src="/futsaly-mark.svg" width={58} height={58} alt="Futsaly" />
      <h1 style={{ margin: '22px 0 8px' }}>Accept invitation</h1>
      <p style={{ color: 'var(--muted)', margin: '0 0 28px' }}>Your Google email is verified against the invited Futsaly account before activation.</p>
      {error && <div className="error" style={{ marginBottom: 14 }}>{error}</div>}
      {token && <GoogleButton onCredential={accept} text="continue_with" disabled={loading} />}
    </div></section>
  </main>;
}
